<div class="terms">
  <ng-container *ngIf="data$ | async as data">
    <div [ngClass]="'labelTC' + (businessType | titlecase)">
      <ng-container *ngIf="activeCountry$ | async as country">
        <ng-container *ngIf="countryTermsSetting(country, activeLanguage$ | async) as termsCondition">
          <h1 [ngClass]="getClass(country)">
            {{ 'termsConditions.termsConditionsLabel' + termsCondition?.tcLabel | cxTranslate }}
          </h1>
          <p class="updated-date" *ngIf="currentDate && termsCondition?.showDate">
            {{ 'termsConditions.lastUpdated' + termsCondition?.tcLastUpdated | cxTranslate }}
            <span>{{
              currentDate
                | date
                  : ((showDynamicDateFormat$ | async) || (country === 'es' && businessType === 'fish')
                      ? (dateFormat$ | async)
                      : 'yyyy/MM/dd')
            }}</span>
          </p>
        </ng-container>
      </ng-container>
      <p [innerHTML]="data.content"></p>
    </div>
  </ng-container>
</div>
